<template>
  <!-- 地址列表 -->
  <div class="con">
    <van-action-sheet
      title="配送至"
      :closeable="false"
      :round="false"
      v-model="show"
      @close="close"
    >
      <div
        v-for="(i, index) in actions"
        :key="index"
        class="clearfix list_adress"
        @click="clickListItem(index)"
      >
        <img
          src="@/assets/product/icon_location@2x.png"
          alt=""
          class="left location_icon"
        />
        <div class="left font12 font_weight400 line_height_17 colo087">
          {{ i.name }}
        </div>
        <img
          v-if="index !== actions.length - 1"
          src="@/assets/product/icon_choose_black@2x.png"
          alt=""
          class="right choose_icon"
        />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      actions: [
        { name: "浙江省 杭州市 滨江区 江虹路459号 英飞特大厦 E座…" },
        { name: "江苏省 南京市 建邺区 兴隆街道657号 所望SOHO 3..." },
        { name: "选择其他区域" }
      ]
    };
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    clickListItem(index) {
      if (index !== this.actions.length - 1) {
        // console.log(index, 1111);
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = true;
        this.$emit("closeSheet");
        this.$emit("selectSheet");
      }
      this.$emit("clickListItem");
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  ::v-deep .van-action-sheet__header {
    padding: 14px 10px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  ::v-deep .van-action-sheet__content {
    margin-bottom: 144px;
  }
  .list_adress {
    padding: 15px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    .location_icon {
      width: 16px;
      margin-right: 4px;
    }
    .choose_icon {
      width: 18px;
    }
  }
}
</style>
